import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import _indexOf from 'lodash/indexOf';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { purgeStoredState } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';

import Button from 'kepler/lib/components/Button';
import {
  cancelEmailFormNoIntent,
  preserveDataNoIntent,
  sendEmailNoIntent,
} from '../actions/action-email-form-no-intent';
import { WebForm } from '../components/common/index';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import { CONTACT_OPTION, WEBFORM_FIELDS_DETAILS, WEBFORM_OTHER_FIELD_DETAILS } from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { hideSubmitButton } from '../../lib/emailUtil';
import { topicTcodeMapping, getRcKeyNameForL1Selection, getRcKeyNameForL2Selection } from '../../lib/PPMEmailUtils';
import { initiateAsyncChat, isMessageUsAvailable } from '../../lib/asyncMessageHelper';
import ContactOption from '../components/ContactOption';
import dispatchLogin from '../actions/action-login-redirect';
import { loadModalContainer, loginFromEmailPage } from '../actions/action-login-modal';
import { emailWebFormTopicRefIds, modalChannels } from '../constants/UtilVariables';
import { requestLoggedOutChatValidation } from '../../lib/loggedOutChatHelper';
import { isPUIIntentEnabled } from '../../lib/puiTopicHelper';
import { asyncOrigins } from '../../common/commonConstants';
import { isNodeChatAlreadyExists, isPrivacyWebFormEnabledInRC } from '../../lib/globalHelper';
import { getLastPathVariable, getQueryValue } from '../../lib/location-helper';

const isSmcEnabled = Page.getIsSmcEnabled();
const privacyRefId = 'PRIV001';
const paypalmeRefId = 'PAYPALME001';
const ppgfRefId = 'PPGF001';
export const SELECT_VIOLATION = 'select_violation';
const paypalmeSecondSelect = 'select_violation_type_all'; // PayPal.Me AUP second layer topic selection

const emailUs = {
  submit: i18n.message('smarthelp/emailUs.emailUs.submit'),
  reset: i18n.message('smarthelp/emailUs.emailUs.reset'),
  errors: i18n.message('smarthelp/emailUs.emailUs.errors'),
  loginText: i18n.message('smarthelp/emailUs.webFormPage.login'),
  loginInstructions: i18n.message('smarthelp/emailUs.webFormPage.loginInstructions'),
  pageInfo: i18n.message('smarthelp/emailUs.webFormPage.info'),
  pageInstructions: i18n.message('smarthelp/emailUs.webFormPage.inst'),
  messageHeader: i18n.message('smarthelp/contactOption.messageUs.header'),
  messageText: i18n.message('smarthelp/contactOption.messageUs.text'),
  header: i18n.message('smarthelp/emailUs.emailUs.header'),
  sendEmail: i18n.message('smarthelp/emailUs.emailUs.sendEmail'),
};

class EmailForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isContactLinkClicked: false,
    };
  }

  static getCustomFieldPayLoad(formFields) {
    if (!Array.isArray(formFields) || formFields.length < 1) {
      return [];
    }
    return formFields.map((field) => ({
      name: Page.webformNameReconstuctor(field.name),
      value: field.value,
    }));
  }

  static getCustomFields(formData) {
    let formFields = [];
    let payload = [];

    if (!_isEmpty(formData) && formData.length > 1) {
      formFields = formData.filter((field) => {
        const fieldTypes = ['text', 'number', 'textarea', 'date', 'select'];
        if (_indexOf(fieldTypes, field.type) > -1) {
          if (field.type === 'textarea' && field.label === 'Message') {
            return false;
          }
          return true;
        }
        return false;
      });

      payload = EmailForm.getCustomFieldPayLoad(formFields);
    }

    return payload;
  }

  /**
   * Function returns payment_info field value for assigning the value to message field
   */
  static getIpinfringementMessage(formFields = []) {
    let messageField = '';
    if (Array.isArray(formFields) && formFields.length) {
      /* eslint-disable array-callback-return */
      formFields.find((field) => {
        if (field.id === 'payment_info') {
          messageField = field.value;
        }
      });
    }
    return messageField;
  }

  componentDidMount() {
    // FPTI tracking for topic tree in EmailByPass page
    // Do not fire FPTI for new privacy page as we are already firing in PrivacyEmailForm
    const { kanaCode } = this.props.selectedDetails;
    // THIS FPTI Executes only for payPalMe/aupviolation as kanaCode is available on page load only for paypalme and ipinfringement
    if (this.props.display && kanaCode && !isPrivacyWebFormEnabledInRC(kanaCode)) {
      const pageName = getLastPathVariable(window.location);
      trackPage({ id: `${pageName}WebformShown`, link: `smarthelp-${pageName}-webform` });
    }
  }

  componentDidUpdate(prevProps) {
    // FPTI tracking for topic tree in EmailByPass page
    // Do not fire FPTI for new privacy page as we are already firing in PrivacyEmailForm
    // Do not fire FPTI for aup violation as we are already firing in did mount
    const { kanaCode } = this.props.selectedDetails;
    const pageName = getLastPathVariable(window.location);
    if (
      !prevProps.display &&
      this.props.display &&
      kanaCode &&
      !isPrivacyWebFormEnabledInRC(kanaCode) &&
      pageName !== 'aupviolation'
    ) {
      trackPage({ id: `${pageName}WebformShown`, link: `smarthelp-${pageName}-webform` });
    }
  }

  handleFormSubmit() {
    return (formData) => {
      const messageField = _find(formData, { type: 'textarea' });
      const payload = {
        message: _get(messageField, 'value', ''),
        topic_code: this.props.selectedDetails.kanaCode,
        subject: this.props.selectedDetails.subTopicName,
        topicName: this.props.selectedDetails.topicName,
        subTopicName: this.props.selectedDetails.subTopicName,
        custom_fields: EmailForm.getCustomFields(formData),
        _csrf: Page.getCSRFtoken(),
      };

      // SMTP logout Email form require email, first_name, last_name in the request body to validate request
      const emailRef = Page.getLogoutEmailRefId();
      if (emailRef === privacyRefId && Array.isArray(formData) && formData.length > 3) {
        // HACK: Privacy Emailform; Checking the Email which the sequence as FirstName, LastName, Email
        payload.first_name = formData[0].value;
        payload.last_name = formData[1].value;
        payload.email = formData[2].value;
      } else if (emailRef === paypalmeRefId && Array.isArray(formData) && formData.length > 3) {
        // HACK: PayPalMe Emailform for firsName, lastName and email
        const formLength = formData.length;
        payload.first_name = formData[formLength - 3].value;
        payload.last_name = formData[formLength - 2].value;
        payload.email = formData[formLength - 1].value;

        const venmoQuery = getQueryValue('reqFromVenmo', window.location);
        const venmoImageUrl = window.venmo_img_url || '';

        // Adding image url to payload if available and only when reqFromVenmo query param exists
        if (venmoQuery === 'true' && venmoImageUrl) {
          trackPage({ id: 'aupviolationVenmoImage', link: 'smarthelp-aupviolation-webform-venmo-image-available' });
          payload.image_url = venmoImageUrl;
        }

        // Update topic Ref id base on the PayPalMe second layer topic selection
        const primarySelection = _find(formData, (field) => field.name === SELECT_VIOLATION);
        const secondarySelection = _find(formData, (field) => field.name === paypalmeSecondSelect);
        if (primarySelection && primarySelection.value && secondarySelection && secondarySelection.value) {
          // Get the RC key name for L1 and L2 selections
          const l1SelectionRCKeyName = getRcKeyNameForL1Selection(primarySelection.value);
          const l2SelectionRCKeyName = getRcKeyNameForL2Selection(secondarySelection.value);
          payload.topic_code = topicTcodeMapping(l1SelectionRCKeyName, l2SelectionRCKeyName);
        }
      } else if (emailRef === ppgfRefId && Array.isArray(formData)) {
        // HACK: PPGF Emailform; email field as the second, first name in the third, last name field in the forth
        payload.email = formData[2].value;
        payload.first_name = formData[3].value;
        payload.last_name = formData[4].value;
      } else if (isPUIIntentEnabled() && Array.isArray(formData) && formData.length > 3) {
        // Payuponinvoice Email; Checking the Email with the sequence as FirstName, LastName, Email
        payload.first_name = formData[0].value;
        payload.last_name = formData[1].value;
        payload.email = formData[2].value;
      } else if (
        emailRef === emailWebFormTopicRefIds.ipInfringement &&
        Array.isArray(formData) &&
        formData.length > 3
      ) {
        const formLength = formData.length;
        payload.first_name = formData[formLength - 3].value;
        payload.last_name = formData[formLength - 2].value;
        payload.email = formData[formLength - 1].value;
        // making payment_info field the message field,
        // to meet the requirements for sending logged out emails, since all the others are custom fields
        payload.message = EmailForm.getIpinfringementMessage(formData);
      }

      // Email form FPTI tracking
      if (
        emailRef === privacyRefId ||
        emailRef === paypalmeRefId ||
        emailRef === ppgfRefId ||
        emailRef === emailWebFormTopicRefIds.ipInfringement
      ) {
        trackLink({
          id: `${getLastPathVariable(window.location)}WebformEmailFormSubmit`,
          link: `smarthelp-submit-email-${getLastPathVariable(window.location)}-form|${
            this.props.selectedDetails.topicName
          }|${emailRef}`,
        }); // Logout webfrom submission tracking
      } else {
        trackLink({
          id: 'emailByPassPage',
          link: `smarthelp-submit-email-form|${this.props.selectedDetails.topicName}|${this.props.selectedDetails.kanaCode}`,
        });
      }

      const thankyouPageDescription = Page.getEmailThankYouPageDescription(
        this.props.topicTreeSelectionL1Reference,
        this.props.selectedDetails,
      );
      this.props.sendEmailNoIntent({
        emailPayload: payload,
        hasCommunityAccess: this.props.hasCommunityAccess,
        isSmcEnabled,
        thankyouPageDescription,
      });
    };
  }

  /**
   * When contact us link is clicked on email page
   */
  handleContactLinkClick(event) {
    const { kanaCode } = this.props.selectedDetails;
    const { isContactLinkClicked } = this.state;
    if (event && event.target && !isContactLinkClicked) {
      this.setState({
        isContactLinkClicked: true,
      });
      // fpti tracking contact-us link click for payuponinvoice
      trackLink({
        id: 'payuponinvoiceWebformContactUsClick',
        link: `smarthelp-contact-us-link-clicked-on-payuponinvoice-Page|${kanaCode}`,
      });
    }
  }

  getWebForm() {
    // If the email is sent and waiting for the response do no allow user to send another email
    const { isMessageSending } = this.props;
    const { kanaCode } = this.props.selectedDetails;
    // Changing the label on sending email button for privacy page new design
    const isnewPrivacyPageEnabled = isPrivacyWebFormEnabledInRC(kanaCode);
    const submitEmailLabel = isnewPrivacyPageEnabled ? emailUs.sendEmail : emailUs.submit;
    const submitClassName = isnewPrivacyPageEnabled ? 'privacy-submit-btn' : '';
    return (
      <div className="form-fields">
        <WebForm
          fields={this.props.fieldDetails}
          submitLabel={submitEmailLabel}
          resetLabel={emailUs.reset}
          errors={emailUs.errors}
          handleFieldValue={this.props.preserveDataNoIntent}
          handleCancel={this.cancelEmailForm()}
          hasCancelButton={this.renderCancelButton()}
          handleSubmit={isMessageSending ? () => {} : this.handleFormSubmit()}
          submitButtonStyle={`left-col col-xs-6 col-sm-6 col-md-6 col-lg-6
            ${hideSubmitButton(this.props.fieldDetails)} ${submitClassName}`}
          cancelButtonStyle="right-col col-xs-6 col-sm-6 col-md-6 col-lg-6"
        />
      </div>
    );
  }

  loginHandler() {
    const { kanaCode } = this.props.selectedDetails;
    trackLink({ id: `${getLastPathVariable(window.location)}WebformLogin`, link: `email-login-click|${kanaCode}` });
    const currentURI = Page.getCurrentLocationURL();
    this.props.loginFromEmailPage();
    return this.props.dispatchLogin(currentURI);
  }

  messageUsContainer() {
    return (
      <ContactOption
        key="message"
        id="contact-message-option"
        contactLinkCSS="btn vx_btn-link contact-link"
        iconClass="contact-panel__vx_btn-link_icon-message"
        text={emailUs.messageHeader}
        message={emailUs.messageText}
        supportMessageCSS="support-message"
        clickAction={() => this.messageUsClickHandler()}
      />
    );
  }

  messageUsClickHandler() {
    // If chat/message us window already exists return null
    if (isNodeChatAlreadyExists()) {
      return null;
    }

    const { kanaCode } = this.props.selectedDetails;
    // fpti tracking message us for payuponinvoice form in de
    trackLink({
      id: 'payuponinvoiceWebformMesssageUsClicked',
      link: `message-us-option-clicked|payuponinvoice|${kanaCode}`,
    });
    // Logged out - open the modal
    if (!Page.isLoggedIn()) {
      this.props.requestLoggedOutChatValidation(kanaCode);
      return this.props.loadModalContainer(modalChannels.messageUs, '', false, true);
    }

    // Logged In - open message us
    return initiateAsyncChat({ topicRefId: kanaCode, origin: asyncOrigins.FINAL_CONTACT_OPTIONS });
  }

  cancelEmailForm() {
    return () => {
      trackLink({ id: 'emailByPassPage', link: `smarthelp-cancel-email-form|${this.props.selectedDetails.topicName}` });
      this.props.cancelEmailFormNoIntent();
    };
  }

  parseContent(linkContent) {
    if (!linkContent) {
      return;
    }

    const contentLinks = linkContent.querySelectorAll('a[href]');
    Array.from(contentLinks).forEach((link) => {
      link.addEventListener('click', (e) => this.handleContactLinkClick(e));
    });
  }

  renderCancelButton() {
    const { kanaCode } = this.props;
    // Do not render cancel button for topics in logoutEmailMapping Remote Config and for DE PayUponInvoice topic
    return !(Page.getLogoutEmailRefId() || isPUIIntentEnabled(kanaCode));
  }

  renderEmailContainer() {
    let emailContainer = null;
    setTimeout(() => purgeStoredState({ storage: asyncSessionStorage }).then(() => {}), 1000);
    if (this.props.display) {
      emailContainer = <div className="email-us-container">{this.getWebForm()}</div>;
    } else if (this.props.error) {
      emailContainer = (
        <div className="error-email-no-intent">
          <div className="vx_icon vx_icon-large vx_icon-critical-large test" />
          <div className="error-message-email-no-intent">{emailUs.errors.message}</div>
        </div>
      );
    }
    return emailContainer;
  }

  renderContactContainer() {
    const { contactChannels, isIdiServiceLoaded, kanaCode, fromChannel, display } = this.props;

    // Waiting for IDI service to load as wee need to display the email or message us based on IDI response
    if (!isIdiServiceLoaded) {
      return <div />;
    }

    // If message us is available in IDI options render message us icon
    if (isMessageUsAvailable(contactChannels)) {
      // Opens async chat during logout to login after message us click
      // logout to login will be true only if fromchannel exists
      // and only for email page open async chat
      if (Page.isLoggedIn() && fromChannel === modalChannels.messageUs && display) {
        initiateAsyncChat({ topicRefId: kanaCode, origin: asyncOrigins.FINAL_CONTACT_OPTIONS });
      }
      return this.messageUsContainer();
    }

    // If message us is not available in IDI options render hardcoded webforms from SAC
    return (
      <div>
        <p className="email-no-intent-header">{emailUs.header}</p>
        {this.renderEmailContainer()}
      </div>
    );
  }

  // Logged in Information on the PAYPUI001 Tcode email page
  // This content will be displayed only during logged out
  renderLoginInfo() {
    if (Page.isLoggedIn()) {
      return <div />;
    }
    return (
      <div className="webform_page_header__login_details">
        <p className="webform_page_header__login_details__login_text">{emailUs.loginInstructions}</p>
        <Button
          className="webform_page_header__login_details__login_btn"
          size="md"
          type="primary"
          onClick={() => this.loginHandler()}
        >
          {emailUs.loginText}
        </Button>
      </div>
    );
  }

  renderPageInfo() {
    const pageInfoAttrs = {
      className: 'webform_page_header__page_info',
    };

    const innerHTML = Page.getHTMLElement({ message: emailUs.pageInfo, useHTML: true });
    return (
      <p
        {...pageInfoAttrs}
        ref={(el) => {
          this.parseContent(el);
        }}
      >
        {innerHTML}
      </p>
    );
  }

  renderWebformHeader() {
    // if the email returns error after submission return empty div instead of the information on the page
    if (this.props.error) {
      return <div />;
    }
    return (
      <div className="webform_page_header">
        {this.renderLoginInfo()}
        {this.renderPageInfo()}
        <p className="webform_page_header__page_instructions">{emailUs.pageInstructions}</p>
      </div>
    );
  }

  render() {
    const { kanaCode } = this.props.selectedDetails;

    // Waiting for kana code to load the content
    // As we need to load the content based on kanacode
    if (!kanaCode) {
      return <div />;
    }

    // only if the request is from Pay upon invoice and DE Market render UI based on IDI response
    if (isPUIIntentEnabled(kanaCode)) {
      return (
        <div>
          {this.renderWebformHeader()}
          {this.renderContactContainer()}
        </div>
      );
    }

    return this.renderEmailContainer();
  }
}

function mapStateToProps(state) {
  return {
    hasCommunityAccess: state.contactChannels.channels.some((channel) => channel.type === 'community'),
    fieldDetails: state.emailNoIntent.fields,
    selectedDetails: {
      topicId: state.emailNoIntent.fieldPrefix,
      kanaCode: state.emailNoIntent.kanaCode,
      topicName: state.emailNoIntent.topicName,
      subTopicName: state.emailNoIntent.subTopicName,
      pageflow: '',
    },
    topicTreeSelectionL1Reference: state.topicTree.topicTreeSelectionL1
      ? state.topicTree.topicTreeSelectionL1.ref_id
      : undefined,
    display: state.emailNoIntent.display,
    error: state.emailNoIntent.error,
    isIdiServiceLoaded: state.contactChannels.isIdiServiceLoaded,
    contactChannels: state.contactChannels.IDIAvailability,
    fromChannel: state.modal.fromChannel,
    isMessageSending: state.emailNoIntent.isMessageSending,
  };
}

EmailForm.propTypes = {
  fieldDetails: PropTypes.arrayOf(PropTypes.shape(WEBFORM_FIELDS_DETAILS)),
  selectedDetails: PropTypes.shape(WEBFORM_OTHER_FIELD_DETAILS),
  preserveDataNoIntent: PropTypes.func.isRequired,
  cancelEmailFormNoIntent: PropTypes.func.isRequired,
  sendEmailNoIntent: PropTypes.func.isRequired,
  display: PropTypes.bool,
  hasCommunityAccess: PropTypes.bool,
  error: PropTypes.bool,
  topicTreeSelectionL1Reference: PropTypes.string,
  isIdiServiceLoaded: PropTypes.bool.isRequired,
  contactChannels: PropTypes.arrayOf(PropTypes.shape(CONTACT_OPTION)),
  dispatchLogin: PropTypes.func.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  fromChannel: PropTypes.string,
  kanaCode: PropTypes.string.isRequired,
  isMessageSending: PropTypes.bool.isRequired,
  requestLoggedOutChatValidation: PropTypes.func.isRequired,
  loginFromEmailPage: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      preserveDataNoIntent,
      cancelEmailFormNoIntent,
      sendEmailNoIntent,
      dispatchLogin,
      loadModalContainer,
      requestLoggedOutChatValidation,
      loginFromEmailPage,
    },
    dispatch,
  );
}

EmailForm.defaultProps = {
  fieldDetails: [],
  selectedDetails: {},
  display: false,
  hasCommunityAccess: false,
  error: false,
  topicTreeSelectionL1Reference: undefined,
  fromChannel: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailForm);
